import {registerLocaleData} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {TranslateService} from '@ngx-translate/core';
import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {HttpCommunicationsModule, IncrementalJsonStorageService, InternationalizationModule, reducer, TokenInterceptorEffects} from 'sp-arch-lib';
import {AppRoutingModule} from 'sp-mark/app-routing.module';
import {AppComponent} from 'sp-mark/app.component';
import {BootEffects} from 'sp-mark/feature-modules/boot/redux/boot.effects';
import * as fromPaymentConclusion from 'sp-mark/redux/payment-conclusion/payment-conclusion.reducers';
import * as fromBoot from 'sp-mark/feature-modules/boot/redux/boot.reducers';
import {RouterEffects} from 'sp-mark/redux/router/router.effects';
import * as fromRouter from 'sp-mark/redux/router/router.reducers';
import {DialogEffects, SnackbarEffects, SpContainerModule, SpDialogComponent, SpDialogModule, SpLoaderModule, SpLoginModule, SpMerchantRegisteredModule, SpSnackBarTemplateComponent, SpSnackBarTemplateModule} from 'sp-ui-lib';
import {environment} from 'sp-mark-src/environments/environment';
import {PaymntConclusionEffects} from 'sp-mark/redux/payment-conclusion/payment-conclusion.effects';
import {GoogleMapsModule} from '@angular/google-maps';
import {ConcludeSellingEffects} from './redux/conclude-selling/conclude-selling.effects';

registerLocaleData(localeIt, 'it');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SpContainerModule,
    SpSnackBarTemplateModule,
    SpMerchantRegisteredModule,
    InternationalizationModule,
    PerfectScrollbarModule,
    SpLoginModule,
    SpLoaderModule,
    SpDialogModule,
    GoogleMapsModule,
    HttpCommunicationsModule.forRoot({baseUrl: environment.baseUrl}),
    StoreModule.forRoot({
      router: fromRouter.reducer,
      boot: fromBoot.reducer,
      paymentConclusion: fromPaymentConclusion.reducer,
      token: reducer
    }),
    EffectsModule.forRoot([RouterEffects, DialogEffects, TokenInterceptorEffects, BootEffects,
      SnackbarEffects,
      PaymntConclusionEffects, ConcludeSellingEffects]),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
  ],
  entryComponents: [SpDialogComponent, SpSnackBarTemplateComponent],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: {
        suppressScrollX: true
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(incrementalJSONStorageSvc: IncrementalJsonStorageService, translateService: TranslateService) {
    incrementalJSONStorageSvc.checkManagePath(`./assets/translate/ui-lib/${translateService.getBrowserLang()}.json`);
    incrementalJSONStorageSvc.checkManagePath(`./assets/translate/shared/${translateService.getBrowserLang()}.json`);

    translateService.addLangs(['en', 'it']);
    translateService.setDefaultLang('it');
    translateService.use(translateService.getBrowserLang());
  }
}
